import React from 'react';
import Hero from '../components/Hero';
import Philosophy from '../components/Philosophy';
import Creations from '../components/Creations';
import Gallery from '../components/Gallery';
import NewsSection from '../components/NewsSection';
import Ingredients from '../components/Ingredients';
import OrderProcess from '../components/OrderProcess';
import ChefSection from '../components/ChefSection';
import HomeContact from '../components/HomeContact';
import { useSettings } from '../context/SettingsContext';

const Home = () => {
    const { settings } = useSettings();
    return (
        <>
            <Hero />
            <ChefSection />
            <Creations />
            <NewsSection />
            <Gallery />
            <Ingredients />
            {!settings.isClickCollectDisabled && <OrderProcess />}


            <div style={{ backgroundColor: 'var(--color-cream)' }}>
                <Philosophy />
            </div>

            <HomeContact />
        </>
    );
};

export default Home;
